import { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll';
import {
  ContainerMarginSections,
  DisplayTitle,
  SectionLabel,
  Colors,
  fonts,
} from '../style/GlobalStyles';

const Grid = styled.div`
  display: flex;
  gap: 4rem;
  align-items: flex-start;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 2.5rem;
  }
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const TalkLink = styled.div`
  font-family: ${fonts.body};
  font-size: 1rem;
  color: ${Colors.muted};

  a {
    color: ${Colors.ink};
    font-weight: 600;
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: 4px;
  }
`;

const ListCol = styled.div`
  flex: 1.2;
  width: 100%;
`;

const Item = styled.div`
  border-top: 1px solid ${Colors.line};

  &:last-child {
    border-bottom: 1px solid ${Colors.line};
  }
`;

const Q = styled.button`
  width: 100%;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 1.2rem;
  padding: 1.6rem 0.25rem;
  text-align: left;

  .n {
    font-family: ${fonts.body};
    font-size: 0.95rem;
    color: ${Colors.muted};
  }
  .q {
    font-family: ${fonts.display};
    text-transform: uppercase;
    font-size: clamp(1rem, 2.2vw, 1.4rem);
    color: ${Colors.ink};
    flex: 1;
    letter-spacing: 0.5px;
  }
  .chev {
    font-size: 1rem;
    color: ${Colors.ink};
    transition: transform 0.3s ease;
    transform: rotate(${({ $open }) => ($open ? '180deg' : '0deg')});
  }
`;

const A = styled.div`
  display: grid;
  grid-template-rows: ${({ $open }) => ($open ? '1fr' : '0fr')};
  transition: grid-template-rows 0.4s ease;
`;

const AInner = styled.div`
  overflow: hidden;

  p {
    font-family: ${fonts.body};
    font-size: 1rem;
    line-height: 1.7;
    color: ${Colors.muted};
    margin: 0;
    padding: 0 3.4rem 1.8rem 3.4rem;

    @media (max-width: 560px) {
      padding: 0 0 1.5rem 0;
    }
  }
`;

const Faq = ({ faq = [] }) => {
  const [open, setOpen] = useState(0);

  return (
    <ContainerMarginSections>
      <Grid>
        <Left>
          <SectionLabel className="gsap-fade-up">FAQ</SectionLabel>
          <DisplayTitle className="gsap-fade-up">
            Everything you
            <br />
            need to know
          </DisplayTitle>
          <TalkLink className="gsap-fade-up">
            Need personalized answers?{' '}
            <Link to="contact" smooth spy>
              Let's talk →
            </Link>
          </TalkLink>
        </Left>

        <ListCol className="gsap-fade-up">
          {faq.map((f, i) => (
            <Item key={f.q}>
              <Q $open={open === i} onClick={() => setOpen(open === i ? -1 : i)}>
                <span className="n">{String(i + 1).padStart(2, '0')}.</span>
                <span className="q">{f.q}</span>
                <span className="chev">⌄</span>
              </Q>
              <A $open={open === i}>
                <AInner>
                  <p>{f.a}</p>
                </AInner>
              </A>
            </Item>
          ))}
        </ListCol>
      </Grid>
    </ContainerMarginSections>
  );
};

export default Faq;
